export function findLastLogLine(lines: string[], type: string, messageIncludes?: string): string | null {
  for (let index = lines.length - 1; index >= 0; index -= 1) {
    const line = lines[index]
    const parts = line.split(' ')
    if (parts.length < 3) {
      continue
    }
    if (parts[1] !== type) {
      continue
    }
    const rest = parts.slice(2).join(' ')
    if (messageIncludes && !rest.includes(messageIncludes)) {
      continue
    }
    return rest
  }

  return null
}
